import PropTypes from 'prop-types';
import React from 'react';

const ScrollToOffset = ({ id, offset }) => {
  return (
    <>
      <div className="scroll-to-offset" id={id} />

      <style jsx>{`
        .scroll-to-offset {
          pointer-events: none;
          transform: translateY(${offset}px);
        }
      `}</style>
    </>
  );
};

ScrollToOffset.propTypes = {
  id: PropTypes.string,
  offset: PropTypes.number,
};

ScrollToOffset.defaultProps = {
  id: '',
  offset: -20,
};

export default ScrollToOffset;
